import { useMemo, useState, Fragment } from 'react'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { Checkbox } from '@progress/kendo-react-inputs'
import { ListView } from '@progress/kendo-react-listview'
import { Grid, useMediaQuery } from '@material-ui/core'
import ButtonHLPure from '../buttonHL/buttonHL.pure'
import './dialog-assign.css'

const DialogAssign = ({t, conversationId, data, onClose, onAssign}) => {
    // #region variables
    const isMobile = useMediaQuery('(max-width:700px)')
    let { categories, users } = data
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null)
    const [showUsers, setShowUsers] = useState(false)
    // #endregion vaiables

    // #region effect
    const dataUsers = useMemo(() => {
        if (categories && users) {
            const targetPermissionId = categories.find(x => x.id === selectedCategory)?.permissionId || null
            return users.filter(user => user.permissionId === targetPermissionId)
        } else { return [] }
    }, [categories, users, selectedCategory])

    const handleBack = () => {
        setShowUsers(false)
        setSelectedCategory(null)
        setSelectedUser(null)
    }
    // #endregion effects

    // #region methods
    const itemList = (prop) => (<Fragment>
        <div className={`${(showUsers ? selectedUser : selectedCategory) === prop.dataItem.id ? 'selected-item' : 'item-list item-list-format'}`} onClick={() => showUsers ? setSelectedUser(prop.dataItem.id) : setSelectedCategory(prop.dataItem.id)}>
            {prop.dataItem.name}
        </div>
    </Fragment>)

    const handleAssignClose = async (conversationId, categoryId, userId) => {
        onAssign(conversationId, categoryId, userId)
        onClose()
    }
    // #endregion methods

    return (
        <Dialog
            title={t('modal.assign.title')}
            onClose={onClose}
            width={isMobile ? '100%' : '30%'}
            height='auto'
          >
            <Form
            render={(formRenderProps) => (<FormElement>
                <Grid container className=''>
                    <label className={'eticket-form-label'}>{t('modal.assign.categories')}:</label>
                </Grid>
                <Grid container className='grid-button-container-add-bot-name'>
                    {
                        !showUsers ?
                        <Fragment>
                            <Grid item xs={12}>
                                <ListView
                                data={categories}
                                item={itemList}
                                className='list-view-assign'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                id='cb-category'
                                name='cb-category'
                                component={Checkbox}
                                label={t('modal.assign.checkbox')}
                                disabled={selectedCategory === null}
                                />
                            </Grid>
                            <ButtonHLPure 
                            primary
                            nameBtn={formRenderProps.valueGetter('cb-category') ? t('modal.assign.buttonAssign') : t('modal.assign.buttonNext')}
                            onClick={() => (selectedCategory !== null) && (formRenderProps.valueGetter('cb-category') ? handleAssignClose(conversationId, selectedCategory, '') : setShowUsers(true))}
                            />
                        </Fragment> :
                        <Fragment>
                            <Grid item xs={12}>
                                <ListView
                                data={dataUsers}
                                item={itemList}
                                className='list-view-assign'
                                />
                            </Grid>
                            <div style={{ marginRight: '5px' }}>
                                <ButtonHLPure 
                                primary
                                nameBtn={t('modal.assign.buttonBack')}
                                onClick={handleBack}
                                />
                            </div>
                            <div>
                                <ButtonHLPure 
                                primary
                                nameBtn={t('modal.assign.buttonAssign')}
                                onClick={() => selectedUser && handleAssignClose(conversationId, selectedCategory, selectedUser)}
                                />
                            </div>
                        </Fragment>
                    }
                </Grid>
              </FormElement>)}
            />
          </Dialog>
    )
}

export {DialogAssign as default}